import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { MENU_RENTAL_PORTAL_ITEM } from '../../../constants/menu'
import { ROUTE_PATH_LIST_RENTAL_PORTAL } from '../../../constants/route'
import { usePageBrowserTabTitle } from '../../../hooks'
import { Page } from '../../Page'
import { PageEmptyState } from '../../PageEmptyState'
import { PageHeader } from '../../PageHeader'
import { QA_NAME_RENTAL_PORTAL_PAGE } from '../RentalPortal.constants'
import { getRentalPortalSubsectionByPathname } from '../RentalPortal.utils'

function RentalPortalSubsectionPage() {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const subsection = getRentalPortalSubsectionByPathname(pathname)

  usePageBrowserTabTitle({ pageTitle: t(subsection.title) })

  const breadcrumbs = [
    {
      id: MENU_RENTAL_PORTAL_ITEM.title,
      title: t(MENU_RENTAL_PORTAL_ITEM.title),
      to: `/${ROUTE_PATH_LIST_RENTAL_PORTAL.root}`,
    },
    { id: subsection.title, title: t(subsection.title) },
  ]

  return (
    <Page qaName={QA_NAME_RENTAL_PORTAL_PAGE}>
      <PageHeader breadcrumbs={breadcrumbs} title={t(subsection.title)} />
      <PageEmptyState
        EntityIcon={subsection.EmptyStateIcon}
        text={t(subsection.emptyTextKey)}
      />
    </Page>
  )
}

export default RentalPortalSubsectionPage
